import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import { ds } from 'mewe/stores/ds';

export let AppEventSettingsRouteBase = {
  theme: Theme.EVENT,

  model() {
    return {
      eventState: ds.eventPages[this.paramsFor('app.event').event_id],
    };
  },
};

export default Route.extend(AppEventSettingsRouteBase);
